export interface DocumentType {
  documentLabel: string;
  documentName: string;
  documentType: string;
}

export enum DOCUMENT_TYPE {
  CIVILID = 'CC',
  FOREIGNERREGISTRATIONCARD = 'CE',
  DIPLOMATICPASSPORT = 'CD',
  PASSPORT = 'PA',
  PERMANENCESAFECONDUCT = 'SC',
  NATIONALALIENREGISTRATIOM = 'PE',
  BITHCERTIFICATE = 'RC',
  CIVILINDETITYRECORD = 'TI',
  BORNALIVESTATEMENT = 'CN',
  UNIDENTIFIEDADULT = 'AS',
  UNIDENTIFIEDMINOR = 'MS',
  TEMPORARYSTAYPERMIT = 'PT',
  FOREIGNERID = 'DE',
}